import { defineMessages } from 'react-intl';

export default defineMessages({
  fullCommitLink: {
    id: 'frontbucket.repository.source.header.fullCommitLink',
    description: 'Label for the link to the full commit',
    defaultMessage: 'Full commit',
  },
  fullCommitTooltip: {
    id: 'frontbucket.repository.source.header.fullCommitTooltip',
    description: 'Tooltip for the link to the full commit',
    defaultMessage: 'View full commit {trimmedHash}',
  },
});
